import React from 'react';
import PropTypes from 'prop-types';

const ArrowRightIcon = (props) => {
  const {
    width, height, fill, className,
  } = props;

  const w = (width) ? width.toString().concat('px') : '24px';
  const h = (height) ? height.toString().concat('px') : '24px';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      className={(className) ? `icon ${className}` : 'icon'}
      viewBox="0 0 24 24"
      width={w}
      height={h}
    >
      <path
        d="M9 6L15 12L9 18"
        stroke={(fill) || '#000'}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

ArrowRightIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  className: PropTypes.string,
};

export default ArrowRightIcon;
